import React, { useState, useEffect } from "react";
import styled from "styled-components";
import getImg from "../../Utils/getImg";
import Axios from "axios";
import { wrapperEndPoint } from "../../Utils/Api";

const menuDetails = [
  {
    title: "Insta Services",
    submenu: [
      {
        title: "Credit Card Services",
        questions: [
          {
            actionText: "I want to make payment for my credit card.",
            displayText: "Credit Card Payment",
          },
          {
            actionText: "How can I book Split N Pay Plus?",
            displayText: "Convert Outstanding into EMI",
          },
          {
            actionText: "How can I change my billing cycle?",
            displayText: "Billing Cycle Change",
          },
          {
            actionText: "How can I block my credit card?",
            displayText: "Block and Reissue Card",
          },
          {
            actionText: "I want to change communication preference for credit card.",
            displayText: "Change Communication Preference",
          },
          {
            actionText: "I want to track my service request.",
            displayText: "Track Service Request",
          },
          {
            actionText: "I want to change statement mode for credit card.",
            displayText: "Statement Mode Change",
          },
          {
            actionText: "How to activate my new Credit Card?",
            displayText: "Activate Credit Card received via Speed Post",
          },
          {
            actionText: "How to start using the credit card to unlock new features?",
            displayText: "Activate to unlock new features",
          },
          {
            actionText: "I want to check my credit card payment status.",
            displayText: "Payment Status",
          },
        ],
      },
      {
        title: "Banking Services",
        questions: [
          {
            actionText: "Where can I find CIF?",
            displayText: "Find your CIF",
          },
          {
            actionText: "How can I add nominee details in my Savings Account?",
            displayText: "Add Nominee",
          },
          {
            actionText: "How can I modify my transaction limit on my Debit Card?",
            displayText: "Debit Card Preference Settings",
          },
          {
            actionText: "How can I block my debit card permanently?",
            displayText: "Hotlisting of Debit Card",
          },
        ],
      },
    ],
  },
  {
    title: "Login",
  },
  {
    title: "Credit Card Services",
    questions:
    [
      {
        "actionText": "Manage Credit Card",
        "displayText": "Switch ON/OFF Card - Card Settings"
      },
      {
        "actionText": "How do I reset Credit Card PIN?",
        "displayText": "Reset Credit Card PIN"
      },
      {
        "actionText": "How to do Split n Pay and convert transactions into EMIs?",
        "displayText": "Book Transactions into EMIs"
      },
      {
        "actionText": "Apply for Credit Card",
        "displayText": "Apply for Credit Card"
      },
      {
        "actionText": "How can I check my credit card statement details?",
        "displayText": "View Credit Card Summary"
      },
      {
        "actionText": "How can I download my statement for credit card?",
        "displayText": "Download Credit Card Statement"
      },
      {
        "actionText": "How can I check my last credit card payment details?",
        "displayText": "Last Payment Details"
      },
      {
        "actionText": "How can I check the minimum amount due?",
        "displayText": "Minimum Amount Due"
      },
      {
        "actionText": "How can I check the total amount due?",//"How can I check the total outstanding amount?",
        "displayText": "Total Amount Due"
      },
      {
        "actionText": "I want last 5 transaction details of my credit card.",
        "displayText": "View Last 5 Transactions"
      },
      {
        "actionText": "How can I check reward points?",
        "displayText": "View Reward Point Summary"
      },
      {
        "actionText": "How to check Credit Limit?",
        "displayText": "Check Credit Limit"
      },
      {
        "actionText": "How to increase my credit limit?",
        "displayText": "Increase Credit Limit"
      }, // UAT 28_05_25 // PREPROD 05_06_25
      {
        "actionText": "How to check billing cycle for credit card?",
        "displayText": "Statement Date / Billing Cycle Date"
      },
      {
        "actionText": "Do you want to view your credit card benefits?", // UAT 28_05_25 // PREPROD 05_06_25
        "displayText": "Credit Card Benefits"
      },
      {
        "actionText": "How can I check cash limit on credit card?",
        "displayText": "Cash Limit"
      },
      {
        "actionText": "How can I enable online transactions on my Credit Card?",
        "displayText": "Enable/Disable - Domestic/International Transaction"
      },
      {
        "actionText": "How can I check if there is any debit on my Credit Card?", //  UAT 17_06_25
        "displayText": "View Last Debit Transactions"
      },
      {
        "actionText": "How can I check if there are any credit or reversals on my Credit Card?", //  UAT 17_06_25
        "displayText": "View Last Credit Transactions"
      },
      {
        "actionText": "How do I check unbilled transactions?",
        "displayText": "Unbilled Transactions"
      },
      {
        "actionText": "How to check the status of my Credit Card?",
        "displayText": "Track Credit Card Application Status"
      },
      {
        "actionText": "How to read Credit Card Statement?",
        "displayText": "Read Credit Card Statement"
      },
      {
        "actionText": "https://webassets.rbl.bank.in/document/Footer%20-%20Grievance%20Redressal/GrievanceRedressalProcess.pdf",
        "displayText": "Grievance Redressal"
      }
    ]
    //  [
    //   {
    //     actionText: "Switch on or off Credit Card",
    //     displayText: "Switch On/Off Credit Card",
    //   },
    //   {
    //     actionText: "How do I reset Credit Card PIN?",
    //     displayText: "Reset credit card PIN",
    //   },
    //   {
    //     actionText: "How to do Split n Pay and convert transactions into EMIs?",
    //     displayText: "Book Transactions into EMIs",
    //   },
    //   {
    //     actionText: "How can I pay my Utility Bill?",
    //     displayText: "Recharge & Pay Utility Bills",
    //   },
    //   {
    //     actionText: "I want to set autopay for my utility bill.",
    //     displayText: "Set Auto-pay for Utility Bills",
    //   },
    //   {
    //     actionText: "Apply for Credit Card",
    //     displayText: "Apply for Credit Card",
    //   },
    //   {
    //     actionText: "How can I check my credit card statement details?",
    //     displayText: "View Credit Card Summary",
    //   },
    //   {
    //     actionText: "How can I opt out of paper statement?",
    //     displayText: "Opt for E-statement",
    //   },
    //   {
    //     actionText: "I want last 5 transaction details of my credit card.",
    //     displayText: "View Last 5 Transactions",
    //   },
    //   {
    //     actionText: "How can I download my statement for credit card?",
    //     displayText: "Download Credit Card Statement",
    //   },
    //   {
    //     actionText: "How can I check my last credit card payment details?",
    //     displayText: "Last Payment Details",
    //   },
    //   {
    //     actionText: "How can I check reward points?",
    //     displayText: "Reward Point Summary",
    //   },
    //   {
    //     actionText: "How to check Credit Limit?",
    //     displayText: "Check Credit Limit",
    //   },
    //   {
    //     actionText: "How can I increase my credit limit?",
    //     displayText: "Increase Credit Limit",
    //   },
    //   {
    //     actionText: "I want to view credit card offers.",
    //     displayText: "Credit Card Offers",
    //   },
    //   {
    //     actionText: "How to check billing cycle for credit card?", // only on UAT(DEV)
    //     displayText: "Statement Cycle Date",
    //   },
    //   {
    //     actionText: "How can I block my credit card?",
    //     displayText: "Switch Off Transactions", // Block Credit Card (Temporary)
    //   },
    //   {
    //     actionText:
    //       "How can I enable international transactions on my Credit Card?",
    //     displayText: "Enable Domestic/International Transactions", // Enable International Transaction
    //   },
    //   {
    //     actionText:
    //       "How can I deactivate international usage on my credit card?",
    //     displayText: "Disable Domestic/International Transactions", // Disable International Transaction
    //   },
    //   {
    //     displayText: "Grievance Redressal",
    //     actionText:
    //       "https://webassets.rbl.bank.in/document/Footer%20-%20Grievance%20Redressal/GrievanceRedressalProcess.pdf",
    //   },
    // ],
  },
  {
    title: "Banking Services",
    questions: 
    [
      {
        "actionText": "How can I check my account balance?",
        "displayText": "Account Balance"
      },
      {
        "actionText": "How can I check my account mini statement?",
        "displayText": "Account Mini Statement"
      },
      {
        "actionText": "How can I download my account statement?",
        "displayText": "Download Account Statement"
      },
      {
        "actionText": "How can I check my account summary?",
        "displayText": "View Account Summary (IFSC and Branch Name)"
      },
      {
        "actionText": "How can I reset my debit card PIN?",
        "displayText": "Reset Debit Card PIN"
      },
      {
        "actionText": "I want to open a Fixed Deposit account.",
        "displayText": "Open Fixed Deposit"
      },
      {
        "actionText": "I want to open a Recurring Deposit account.",
        "displayText": "Open Recurring Deposit"
      },
      {
        "actionText": "How can I add beneficiary?",
        "displayText": "Add Beneficiary"
      },
      {
        "actionText": "How can I delete a beneficiary?",
        "displayText": "Delete Beneficiary"
      },
      {
        "actionText": "How can I transfer funds?",
        "displayText": "Fund Transfer (NEFT/IMPS/RTGS)"
      },
      {
        "actionText": "How can I block my debit card?",
        "displayText": "Block Debit Card"//"Block Debit Card (Temporary)"
      },
      {
        "actionText": "How can I unblock my debit card?",
        "displayText": "Unblock Debit Card"
      },
      {
        "actionText": "I want to apply for a cheque book.",
        "displayText": "Cheque Book Request"
      },
      {
        "actionText": "How can I stop a cheque payment?",
        "displayText": "Stop Cheque Payment"
      },
      {
        "actionText": "Apply for Crest Debit Card",
        "displayText": "Upgrade Crest Debit Card"
      },
      {
        "actionText": "I want to apply for Hospicash.",
        "displayText": "Apply for Hospital Daily Cash Policy"
      },
      {
        "actionText": "Know your required ATM location",
        "displayText": "ATM Locator"
      },
      {
        "actionText": "Know your required branch location",
        "displayText": "Branch Locator"
      },
      {
        "actionText": "https://webassets.rbl.bank.in/document/Footer%20-%20Grievance%20Redressal/GrievanceRedressalProcess.pdf",
        "displayText": "Grievance Redressal"
      }
    ]
    // [
    //   {
    //     displayText: "Apply for Hospital Daily Cash Policy",
    //     actionText: "I want to apply for Hospicash",
    //   },
    //   {
    //     actionText: "Online Utility Bill Payment",
    //     displayText: "Online Utility Bill Payment",
    //   },
    //   {
    //     actionText: "Apply for a deposit account",
    //     displayText: "Open Fixed Deposit / Recurring Deposit Account",
    //   },
    //   {
    //     actionText: "Apply for Crest Debit Card",
    //     displayText: "Upgrade Crest Debit Card",
    //   },
    //   {
    //     actionText: "How can I check my account balance?",
    //     displayText: "Account Balance",
    //   },
    //   {
    //     actionText: "How can I check my account mini statement?",
    //     displayText: "Account Mini Statement",
    //   },
    //   {
    //     actionText: "How can I download my account statement?",
    //     displayText: "Download Account Statement",
    //   },
    //   {
    //     actionText: "How can I check my account summary?",
    //     displayText: "View Account Summary (IFSC & Branch Name)",
    //   },
    //   {
    //     actionText: "How can I transfer funds?",
    //     displayText: "Transfer Funds (NEFT / IMPS)",
    //   },
    //   {
    //     actionText: "How can I add beneficiary?",
    //     displayText: "Add Beneficiary",
    //   },
    //   {
    //     actionText: "How can I delete a beneficiary?",
    //     displayText: "Delete Beneficiary",
    //   },
    //   {
    //     actionText: "How can I block my debit card?",
    //     displayText: "Block Debit Card (Temporary)",
    //   },
    //   {
    //     actionText: "How can I unblock my debit card?",
    //     displayText: "Unblock Debit Card",
    //   },
    //   {
    //     actionText: "How can I reset my debit card PIN?",
    //     displayText: "Reset Debit Card PIN",
    //   },
    //   {
    //     actionText: "How can I update my email address?",
    //     displayText: "Add/Update Email ID",
    //   },
    //   {
    //     actionText: "I want to apply for a cheque book.",
    //     displayText: "Request for Cheque Book",
    //   },
    //   {
    //     actionText: "How can I stop a cheque payment?",
    //     displayText: "Stop Cheque Payment",
    //   },
    //   {
    //     actionText: "Know your required ATM location",
    //     displayText: "ATM Location",
    //   },
    //   {
    //     actionText: "Know your required branch location",
    //     displayText: "Branch Location",
    //   },
    //   {
    //     displayText: "Grievance Redressal",
    //     actionText:
    //       "https://webassets.rbl.bank.in/document/Footer%20-%20Grievance%20Redressal/GrievanceRedressalProcess.pdf",
    //   },
    // ],
  },
  {
    title: "Apply for New Products",
    questions: [
      {
        actionText: "Apply for Current Account",
        displayText: "Apply for Current Account",
      },
      {
        actionText: "Apply for Savings Account",
        displayText: "Apply for Savings Account",
      },
      {
        actionText: "How can I open an NRI account with RBL Bank?",
        displayText: "Apply for NR Account",
      },
      {
        actionText: "Apply for NRI deposit",
        displayText: "Apply for NR Deposit",
      },
      {
        actionText: "I want to open a fixed deposit account.",
        displayText: "Apply for Fixed Deposit",
      },
      {
        actionText: "Apply for Personal Loan",
        displayText: "Apply for Personal Loan",
      },
      {
        actionText: "Apply for Credit Cards",
        displayText: "Apply for Credit Cards",
      },
    ],
  },
  {
    title: "Write To Us",
    questions:
    [
      {
        "actionText": "https://outsys1.rbl.bank.in/WebForm?utm_source=chatbot&utm_medium=referral&utm_campaign=chatbot-menu-writetous",
        "displayText": "Raise a Query/Request/Complaint"
      },
      {
        "actionText": "https://outsys1.rbl.bank.in/WebForm/TrackInteraction?utm_source=chatbot&utm_medium=referral&utm_campaign=chatbot-menu-writetous",
        "displayText": "Track your Request/Complaint"
      }
    ]
  },
  // {
  //   title: "Frequently Asked Questions",
  //   submenu: [
  //     {
  //       title: "Banking",
  //       questions: [
  //         {
  //           displayText: "Apply for Account.",
  //           actionText: "Apply for Account.",
  //         },
  //         {
  //           displayText: "I want to open a Fixed Deposit account.",
  //           actionText: "I want to open a Fixed Deposit account.",
  //         },
  //         {
  //           displayText: "I want to open a Recurring Deposit account.",
  //           actionText: "I want to open a Recurring Deposit account.",
  //         },
  //         // {
  //         //     "displayText": "How can I pay my Utility Bill online?",
  //         //     "actionText": "How can I pay my Utility Bill online?"
  //         // },
  //         {
  //           displayText: "How to block my debit card?",
  //           actionText: "How to block my debit card?",
  //         },
  //         {
  //           displayText: "Where is nearest branch?",
  //           actionText: "Where is nearest branch?",
  //         },
  //         {
  //           displayText: "Where is the nearest ATM?",
  //           actionText: "Where is the nearest ATM?",
  //         },
  //         {
  //           displayText: "How to transfer funds?",
  //           actionText: "How to transfer funds?",
  //         },
  //         {
  //           displayText: "How to apply for a personal loan?",
  //           actionText: "How to apply for a personal loan?",
  //         },
  //         {
  //           displayText: "Interest rate information for Savings account.",
  //           actionText: "Interest rate information for Savings account.",
  //         },
  //         {
  //           displayText: "Invest with us",
  //           actionText: "Invest with us",
  //         },
  //       ],
  //     },
  //     {
  //       title: "Credit Card",
  //       questions: [
  //         {
  //           displayText: "Apply for Credit Card.",
  //           actionText: "Apply for Credit Card.",
  //         },
  //         {
  //           displayText: "How can I pay my Credit Card bills?",
  //           actionText: "How can I pay my Credit Card bills?",
  //         },
  //         {
  //           displayText: "What is Reward Point?",
  //           actionText: "What is Reward Point?",
  //         },
  //         {
  //           displayText: "How to redeem my Reward Point?",
  //           actionText: "How to redeem my Reward Point?",
  //         },
  //         {
  //           displayText: "How do I reset Credit Card PIN?",
  //           actionText: "How do I reset Credit Card PIN?",
  //         },
  //         {
  //           displayText: "What is Xpress Cash?",
  //           actionText: "What is Xpress Cash?",
  //         },
  //         {
  //           displayText: "What is STPL?",
  //           actionText: "What is STPL?",
  //         },
  //         {
  //           displayText: "What is EMI infinity pass?",
  //           actionText: "What is EMI infinity pass?",
  //         },
  //         {
  //           displayText: "Apply for STPL",
  //           actionText: "Apply for STPL",
  //         },
  //         {
  //           displayText: "How can I convert credit card purchase into EMI?",
  //           actionText: "How can I convert credit card purchase into EMI?",
  //         },
  //       ],
  //     },
  //   ],
  // },
];

const MenuBlock = React.memo(({ isMenuVisible, toggleMenu, handleFocus }) => {
  const [showQuestions, setShowQuestions] = useState(false);
  const [activeOption, setActiveOption] = useState(null);
  const [activeSubOption, setActiveSubOption] = useState(null);
  const [botHeight, setBotHeight] = useState(null); //here
  const [botWidth, setBotWidth] = useState(null);

  useEffect(() => {
    if (!isMenuVisible) {
      setShowQuestions(false);
    }

    //here
    let sfMainContainer = document.getElementById("sf-chat-main-container");

    if (sfMainContainer) {
      setBotWidth(
        document
          .getElementById("sf-chat-main-container")
          .getBoundingClientRect().width
      );
      setBotHeight(
        document
          .getElementById("sf-chat-main-container")
          .getBoundingClientRect().height
      );
    }

    window.addEventListener("resize", handleResize);
  }, []);

  const handleResize = () => {
    let sfMainContainer = document.getElementById("sf-chat-main-container");

    if (sfMainContainer) {
      setBotHeight(
        document
          .getElementById("sf-chat-main-container")
          .getBoundingClientRect().height
      );
      setBotWidth(
        document
          .getElementById("sf-chat-main-container")
          .getBoundingClientRect().width
      );
    }
  };

  const handleOnclickBackButton = (activeOption, activeSubOption) => {
    if (activeSubOption != null) {
      setActiveSubOption(null);
    } else {
      setShowQuestions(false);
    }
  };

  const sendAnalyticsforMenu = (data, menuAction) => {
    let analyticsData = {
      name: data,
      type: "Main Menu",
      action: menuAction == "" ? "" : data,
      botid: "vYdoWvH2CVMbJOGnAB11VA==",
    };
    console.log(analyticsData);

    //  let analyticsURL="https://chatbotdev.rbl.bank.in/rcb/GenericChatBot/bannerMenuAnalytics"
    //  let analyticsURL = "https://chatbotpre.rbl.bank.in/bannerMenuAnalytics";
    Axios.post(wrapperEndPoint.analyticsURL, analyticsData)
      // .then(response => response.data)
      .then((response) => {
        console.log(response); //handle sucess
      })
      .catch((error) => {
        console.log(error); //handle error
      });
  };

  //css

  //  height:calc(${botHeight}px - 20px);
  const MenuOptions = styled.div`
    position: absolute;
    display: ${(props) => (props.isMenuVisible ? "block" : "none")};
    height:${botHeight}px;
    width: ${botWidth}px;
    bottom: 0px;
    padding-top:30px;
    // background-color: red;
    background-color: #fcfcfc;
   
    z-index: 10000;
    
    .welcome-title{
        height: auto;
        width: 100%;
        padding: 48px 0px 0px 30px;
        font-size: 18px;
        font-weight: 500;
    }

    .menu-options-head{
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;

        .back-icon-div{
            display: inline-block;
            vertical-align: middle;
            margin-right: 12px;
            height: 21px;
            width: 21px;
        }

        .back-icon-img{
            width:100%;
        }

        .active-option{
            display: inline-block;
            color: #000;
            width: 100%;
            font-size: 16px;
            padding: 35px 28px 12px 28px;
        } 
        // .active-option-icon{
        // }

        .menu-close-icon-div{
            position: absolute;
            // top: 28px;
            // right: 16px;
            top: 68px;
            right: 14px;
           // background: #a12124;
            height: 36px;
            width: 36px;
            border-radius: 36px;
            text-align: center;  
        }

        .menu-close-icon{
            margin-top:5px;
        }
    }

    .menu-options-body{
        display:block;
        height: auto;
        padding-top: 10px;
        overflow: hidden
        overflow-y: auto;
        max-height : 440px;
    
        .each-menu-option{    
            display: flex;
            align-items: center;
            height:56px;
            width: auto;
            margin: 12px 30px;
            padding: 10px;
            background: #fff;
            border: 0.5px solid #fff;
            border-radius: 8px;
            -webkit-box-shadow: 0px 8px 8px rgba(0,0,0,0.1);
                    box-shadow: 0px 8px 8px rgba(0,0,0,0.1);
            cursor: pointer;
        }

        .menu-icon-div{
            height: 40px;
            display: inline-block;
            vertical-align: middle;
            
        }

        .option-name{
            display: inline-block;
            vertical-align: middle;
            padding: 10px 15px; 
            font-size:14px;
            width:78%;

            @media (max-width: 355px){
                width:74%;
            }

            @media (max-width: 311px){
                width:71%;
            }
        
        }

        .chevron-icon-div{
            display: inline-block;
            vertical-align: middle;
            text-align: right;
            width:20px;
        }
        .chevron-icon{
            width: 100%;
        }

        .question{
            width:100%;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-pack: justify;
                -ms-flex-pack: justify;
                    justify-content: space-between;
            padding: 10px 10px;
            color: #666666;
            cursor: pointer;
            background: #fff;        
            // &:not(:last-child){
            //     border-bottom: solid 1px #e2e2e2;
            // }

            &:hover{
                color: #000;
            }
        }
    .question-text{
        max-width: 80%;
    }
  }

    .questions-wrapper{
        background: #fff;
        height: calc(${botHeight}px - 120px);
        width: ${botWidth}px;
        padding: 12px 16px 40px 24px;
        /* overflow-y:scroll; */
        -ms-overflow-style: none;  /* IE and Edge */
        /* scrollbar-width: none; only on dev(uat) */

        ::-webkit-scrollbar {
            width: 9px;
            height: 5px;
        }
    
        ::-webkit-scrollbar-track {
            background: #f7f7f7;
            height: 50px;
        }
    
        ::-webkit-scrollbar-button {
            height: 3px;
        }
    
        ::-webkit-scrollbar-thumb {
            height: 8px;
            border-radius: 3px;
            background-color: #56a0d3;
        }

    }

`;
  //    height: calc(${botHeight}px - 120px);
  return (
    <Menu isMenuVisible={isMenuVisible}>
      <img
        className="menu-open-icon"
        src={getImg(`menu-icons/menu_new.svg`)}
        onClick={() => {
          toggleMenu();
          handleFocus();
        }}
        alt="menu open icon"
      />
      {isMenuVisible ? (
        <MenuOptions isMenuVisible={isMenuVisible}>
          <div className="menu-options-head">
            {showQuestions ? (
              <div className="active-option">
                <div className="back-icon-div">
                  <img
                    className="back-icon-img"
                    src={getImg(`menu-icons/icon_back_arrow_dark.svg`)}
                    onClick={() => {
                      handleOnclickBackButton(activeOption, activeSubOption);
                    }}
                    alt="back to main menu"
                  />
                </div>
                {activeSubOption != null ? (
                  <div
                    style={{ display: "inline-block", verticalAlign: "middle" }}
                  >
                    {menuDetails[activeOption].submenu[activeSubOption].title}
                  </div>
                ) : (
                  <span>{menuDetails[activeOption].title}</span>
                )}
              </div>
            ) : (
              <div className="welcome-title">
                <div
                  style={{
                    fontWeight: "300",
                    color: "#666666",
                    fontSize: "16px",
                    paddingBottom: "10px",
                  }}
                >
                  Hi,
                </div>
                What would you like to do?
              </div>
            )}
            <div className="menu-close-icon-div">
              <img
                className="menu-close-icon"
                src={getImg(`menu-icons/cross-black.svg`)}
                onClick={() => {
                  toggleMenu();
                  setActiveSubOption(null);
                }}
                alt="menu close icon"
              />
            </div>
          </div>

          <div className="menu-options-body">
            {!showQuestions ? (
              <div>
                {menuDetails.map(({ title }, i) => {
                  console.log(i);
                  if (title === "Login") {
                    return (
                      <div
                        key={i}
                        className="each-menu-option"
                        onClick={() => {
                          sendAnalyticsforMenu(title, "Query submitted");
                          window.autosubmit(title, false, "Accordion");
                          toggleMenu();
                        }}
                      >
                        <div className="menu-icon-div">
                          <img
                            src={getImg(`menu-icons/${i}.svg`)}
                            alt="menu open icon"
                          />
                        </div>
                        <div className="option-name">{title}</div>
                        <div className="chevron-icon-div">
                          <img
                            className="chevron-icon"
                            src={getImg(`menu-icons/icon_chevron_blue.svg`)}
                          />
                        </div>
                      </div>
                    );
                  }
                  return (
                    <div
                      key={i}
                      className="each-menu-option"
                      onClick={() => {
                        sendAnalyticsforMenu(title, "");
                        setActiveOption(i);
                        setShowQuestions(true);
                      }}
                    >
                      <div className="menu-icon-div">
                        <img
                          src={getImg(
                            title === "Insta Services"
                              ? `menu-icons/insta-service-menu.svg`
                              : `menu-icons/${i}.svg`
                          )}
                          alt="menu open icon"
                        />
                      </div>
                      <div className="option-name">{title}</div>
                      <div className="chevron-icon-div">
                        <img
                          className="chevron-icon"
                          src={getImg(`menu-icons/icon_chevron_blue.svg`)}
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : menuDetails[activeOption].title == "Banking Services" ||
              menuDetails[activeOption].title == "Credit Card Services" ||
              menuDetails[activeOption].title == "Apply for New Products" ||
              menuDetails[activeOption].title == "Write To Us" ? (
              <div className="questions-wrapper">
                {menuDetails[activeOption].questions.map(
                  ({ displayText, actionText }, j) => {
                    return (
                      <div>
                        {actionText.indexOf("https") > -1 ? (
                          <div
                            key={j}
                            className="question"
                            onClick={() => {
                              sendAnalyticsforMenu(displayText, "");
                              setActiveSubOption(null);
                              toggleMenu();
                            }}
                          >
                            <a
                              className="question-text"
                              href={actionText}
                              target="_blank"
                            >
                              {displayText}
                            </a>
                            <div className="chevron-icon-div">
                              <img
                                className="chevron-icon"
                                src={getImg(`menu-icons/icon_chevron_blue.svg`)}
                              />
                            </div>
                          </div>
                        ) : (
                          <div
                            key={j}
                            className="question"
                            onClick={() => {
                              sendAnalyticsforMenu(
                                displayText,
                                "Query submitted"
                              );
                              window.autosubmit(actionText, false, "Accordion");
                              setActiveSubOption(null);
                              toggleMenu();
                            }}
                          >
                            <div className="question-text">{displayText}</div>
                            <div className="chevron-icon-div">
                              <img
                                className="chevron-icon"
                                src={getImg(`menu-icons/icon_chevron_blue.svg`)}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  }
                )}
              </div>
            ) : (menuDetails[activeOption].title == "Frequently Asked Questions" ||
                menuDetails[activeOption].title == "Insta Services") && activeSubOption == null ? (
              menuDetails[activeOption].submenu.map(
                ({ title, questions }, j) => {
                  // return <div key={j} className="question"  onClick={() => { setActiveSubOption(j); setShowQuestions(true);}}>
                  return (
                    <div
                      key={j}
                      className="each-menu-option"
                      onClick={() => {
                        sendAnalyticsforMenu(title, "");
                        setActiveSubOption(j);
                        setShowQuestions(true);
                      }}
                    >
                      <div className="menu-icon-div">
                        <img
                          src={getImg(`menu-icons/sub-menu-icon/${j === 0 ? 2 : 1}.svg`)}
                          alt="menu open icon"
                        />
                      </div>
                      <div className="option-name">{title}</div>
                      {/* <div className="question-text">{title}</div> */}
                      <div className="chevron-icon-div">
                        <img
                          className="chevron-icon"
                          src={getImg(`menu-icons/icon_chevron_blue.svg`)}
                        />
                      </div>
                    </div>
                  );
                }
              )
            ) : (
              <div className="questions-wrapper">
                {menuDetails[activeOption].submenu[
                  activeSubOption
                ].questions.map(({ displayText, actionText }, j) => {
                  return (
                    <div>
                      {actionText.indexOf("https") > -1 ? (
                        <div
                          key={j}
                          className="question"
                          onClick={() => {
                            setActiveSubOption(null);
                            toggleMenu();
                          }}
                        >
                          <a
                            className="question-text"
                            href={actionText}
                            target="_blank"
                          >
                            {displayText}
                          </a>
                          <div className="chevron-icon-div">
                            <img
                              className="chevron-icon"
                              src={getImg(`menu-icons/icon_chevron_blue.svg`)}
                            />
                          </div>
                        </div>
                      ) : (
                        <div
                          key={j}
                          className="question"
                          onClick={() => {
                            sendAnalyticsforMenu(
                              displayText,
                              "Query submitted"
                            );
                            window.autosubmit(actionText, false, "Accordion");
                            setActiveSubOption(null);
                            toggleMenu();
                          }}
                        >
                          <div className="question-text">{displayText}</div>
                          <div className="chevron-icon-div">
                            <img
                              className="chevron-icon"
                              src={getImg(`menu-icons/icon_chevron_blue.svg`)}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </MenuOptions>
      ) : null}
    </Menu>
  );
});

const Menu = styled.div`
  -ms-flex-item-align: center;
  align-self: center;
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 14px;

  .menu-open-icon {
    margin-left: 10px;
    ${(props) => props.isMenuVisible && ` visibility:hidden;cursor:auto;`}
  }

  img {
    cursor: pointer;
  }
`;

export default MenuBlock;
